export default __webpack_public_path__ + "static/media/icon-wiecej bialka.8b0f9dd3.svg";